export var incomeCardContainer = {
  padding: '1.4em 2.2em 1.4em',
  boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25)',
  borderRadius: 4,
  display: 'flex',
  alignItems: 'center',
  flexFlow: 'row wrap',
  marginBottom: '1em',
  '&:last-of-type': {
    marginBottom: 0
  }
};
export var incomeInformationContainer = function incomeInformationContainer(theme) {
  return {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'row wrap',
    '& .incomeInfoCol': {
      marginRight: '1em',
      flex: '1 0 0',
      wordBreak: 'break-all'
    },
    '& .incomeInfoLabel': {
      textTransform: 'uppercase',
      color: theme.gray300,
      fontSize: '1.2rem',
      marginBottom: 0
    },
    '& .incomeInfoText': {
      fontSize: '1.2rem',
      marginBottom: '1.5em'
    },
    '& .incomeInfoTextClamp': {
      WebkitLineClamp: 3,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      display: '-webkit-box'
    }
  };
};
export var incomeActionsContainer = {
  flex: '0 0 65px',
  display: 'flex',
  justifyContent: 'flex-end'
};
export var incomeActionIcon = {
  margin: '0 2em 1.5em 0',
  flexShrink: 0,
  cursor: 'pointer',
  height: 18,
  '&:last-of-type': {
    marginRight: 0
  }
};